import React from "react";
import "./css/NewCoursesStyle.css"; // CSS alag file me rakhenge
import { Link } from "react-router-dom";
import iconone from './offer-logo/vigyanvriksh_csir.png';
import icontwo from './offer-logo/vigyanvriksh_iitguwahati.png';
import iconthree from './offer-logo/vigyanvriksh_iitbombay.png';
import iconfour from './offer-logo/vigyanvriksh_map.png';
import iconfive from './offer-logo/vigyanvriksh_professer.png';
import iconsix from './offer-logo/vigyanvriksh_chemestory.png';


function CourseCards() {
    return (
    <section className="py-5 coursecardbox">
        <div className="container">
            <div className="text-center mb-5">
                <h2 className="fw-bold">Our Programs & <span className="section-titles">Accreditation</span></h2>
                <p className="text-muted px-5 px-5 px-md-5">Our Programs: Master core concepts through our intensive classroom and online modules designed by subject experts to help you secure top ranks in CSIR NET, GATE, and JAM. Accreditation: Recognized for pedagogical excellence, our programs are structured under the guidance of IIT and CSIR alumni to ensure the highest quality of competitive training.</p>
            </div>

            <div className="row g-4">
                {/* CSIR NET */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>CSIR NET</h5>
                            <div className="tags">
                                <Link to="/CSIR-Net" className="tag">June</Link>
                                <Link to="/CSIR-Net-December" className="tag">December</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons pink">
                            <img src={iconone} alt="CSIR NET" />
                        </div>
                    </div>
                </div>

                {/* IIT GATE */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>IIT GATE</h5>
                            <div className="tags">
                                <Link to="/IIT-Gate-one-year" className="tag">1 Year</Link>
                                <Link to="/IIT-Gate-Two-Year" className="tag">2 Year</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons yellow">
                            <img src={icontwo} alt="IIT GATE" />
                        </div>
                    </div>
                </div>

                {/* IIT JAM */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>IIT JAM</h5>
                            <div className="tags">
                                <Link to="/IIT-Jam-one-year" className="tag">1 Year</Link>
                                <Link to="/IIT-Jam-Two-Year" className="tag">2 Year</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons blue">
                            <img src={iconthree} alt="IIT JAM" />
                        </div>
                    </div>
                </div>

                {/* PGT Chemistry */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>PGT Chemistry</h5>
                            <div className="tags">
                                <Link to="/PGT-Chemistry-One-Year" className="tag">1 Year</Link>
                                <Link to="/PGT-Chemistry-Two-Year" className="tag">2 Year</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons purple">
                            <img src={iconsix} alt="PGT Chemistry" />
                        </div>
                    </div>
                </div>

                {/* Assistant Professor */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>Assistant Professor</h5>
                            <div className="tags">
                                <Link to="/Assistant-Professor-One-Year" className="tag">1 Year</Link>
                                <Link to="/Assistant-Professor-Two-Year" className="tag">2 Year</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons green">
                            <img src={iconfive} alt="Assistant Professor" />
                        </div>
                    </div>
                </div>

                {/* B. Sc. Chemistry */}
                <div className="col-md-4">
                    <div className="category-cards">
                        <div className="category-content">
                            <h5>B. Sc. Chemistry</h5>
                            <div className="tags">
                                <Link to="" className="tag">1 Year</Link>
                                <Link to="" className="tag">2 Year</Link>
                            </div>
                            <Link to="#" className="explore-link">Explore Category →</Link>
                        </div>
                        <div className="category-icons cgreen">
                            <img src={iconfour} alt="B.Sc. Chemistry" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    );
}

export default CourseCards;